import { combineEpics } from "redux-observable";
import { authEpic } from "./security/authEpic";
import { userContextEpic } from "./security/userInfoEpic";

export const portalEpic = combineEpics(authEpic, userContextEpic);
